module.exports = new __parcel__URL__("artifact_0007.2083c39c.png").toString();